import { httpClient } from '@/services/HttpClient';
import { notificationController } from "@/utils/notifications";
class ConnectionStatus {
    connectionStatusEndpointURL = '/api/v1/ping';
    checkStatus() {
        const currentRequestId = this.#lastRequestId = Date.now();
        if (this.#timeoutId) {
            clearTimeout(this.#timeoutId);
            this.#timeoutId = null;
        }
        this.#getStatus()
            .then(({ response }) => {
            if (!response.ok) {
                throw new Error('Ошибка ответа от эндпоинта');
            }
            return true;
        })
            .catch(() => false)
            .then((status) => {
            if (this.#lastRequestId !== currentRequestId) {
                return;
            }
            this.#updateStatus(status);
            this.#timeoutId = setTimeout(() => {
                this.checkStatus();
                this.#timeoutId = null;
            }, 10000);
        });
    }
    get isOnline() {
        return this.#isOnline;
    }
    subscribe(callback) {
        const id = Date.now();
        this.#statusSubscribers.push({ id, callback });
        return id;
    }
    unsubscribe(id) {
        const index = this.#statusSubscribers.findIndex((item) => item.id === id);
        if (index === -1) {
            throw new Error('Указанный id отсутствует в подписках.');
        }
        this.#statusSubscribers.splice(index, 1);
    }
    #isOnline = true;
    #lastRequestId;
    #statusSubscribers = [];
    #timeoutId = null;
    #getStatus() {
        return httpClient.fetch(this.connectionStatusEndpointURL);
    }
    #updateStatus(status) {
        if (this.#isOnline === status) {
            return;
        }
        this.#isOnline = status;
        this.#statusSubscribers.forEach(({ callback }) => {
            callback({ status });
        });
    }
}
export const connectionStatus = new ConnectionStatus();
connectionStatus.checkStatus();
connectionStatus.subscribe(({ status }) => {
    const type = status ? 'success' : 'error';
    const content = status ?
        'Соединение с сервером восстановлено'
        : 'Соединение с сервером потеряно. Приложение будет работать в оффлайн-режиме.';
    notificationController.show({ type, content });
});
